import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-hosting-domains',
  imports: [RouterLink],
  templateUrl: './hosting-domains.html',
  styleUrl: '../service-pages.scss',
})
export class HostingDomains {}
